import { RightOutlined, LeftOutlined } from "@ant-design/icons";

export function PrevArrow({ onClick }) {
  return (
    <button
      className="slick-custom-arrow slick-prev-arrow"
      onClick={onClick}
      aria-label="Previous"
    >
      <LeftOutlined />
    </button>
  );
}

export function NextArrow({ onClick }) {
  return (
    <button
      className="slick-custom-arrow slick-next-arrow"
      onClick={onClick}
      aria-label="Next"
    >
      <RightOutlined />
    </button>
  );
}

export function BannerPrevArrow({ onClick }) {
  return (
    <button
      className="slick-custom-arrow slick-banner-prev-arrow"
      onClick={onClick}
      aria-label="Previous"
    >
      <LeftOutlined />
    </button>
  );
}

export function BannerNextArrow({ onClick }) {
  return (
    <button
      className="slick-custom-arrow slick-banner-next-arrow"
      onClick={onClick}
      aria-label="Next"
    >
      <RightOutlined />
    </button>
  );
}
